export default [
    {
        path: '/resources',
        name: 'resources',
        component: () => import ('./pages/Index')
    },
]